<template>
  <div>
    <v-card-text>
      <v-card>
        <v-data-table
          :headers="collaboratorsHeaders"
          :items="collaboratorsToShow"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          item-key="uuid"
          hide-default-footer
        >
          <template #[`item.firstname`]="{ item }">
            {{ item.firstname + ' ' + item.lastname }}
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn icon @click="showDialog(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-if="totalPages > 1"
          v-model="page"
          :length="totalPages"
        />
      </v-card>
      <div class="pt-4 text-center">
        <v-btn color="primary" large @click="addCollaborator()">{{ getLabel("add_collaborator") }}</v-btn>
      </div>
    </v-card-text>
    <v-dialog
      v-model="dialog"
      min-width="450"
      max-width="500"
    >
      <v-card>
        <v-sheet dark color="grey">
          <v-card-title class="text-h5">
            {{ getLabel("remove_collaborator_group_question") }}
          </v-card-title>
        </v-sheet>

        <v-card-text class="pt-5">
          <p class="ma-0">
            {{ getLabel("name") + ": " + collaboratorToRemove.firstname + " " + collaboratorToRemove.lastname }}
          </p>
          <p class="ma-0">
            {{ getLabel("email") + ": " + collaboratorToRemove.email }}
          </p>
          <p v-if="collaboratorToRemove.mobilephone" class="ma-0">
            {{ getLabel("phone") + ": " + collaboratorToRemove.mobilephone }}
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pt-4">
          <v-spacer />
          <v-btn
            class="mb-2"
            color="red darken-1"
            dark
            large
            @click="dialog = false"
          >
            <v-icon class="mr-2">mdi-close-thick</v-icon>
            {{ getLabel("no") }}
          </v-btn>
          <v-btn
            class="mb-2 ml-2"

            color="green darken-1"
            large
            dark
            @click="removeCollaborator()"
          >
            <v-icon class="mr-2">mdi-check-bold</v-icon>
            {{ getLabel("yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ref, computed, onActivated } from '@vue/composition-api';
import { useRouter } from 'vue2-helpers/vue-router';
import { useMutation } from '@vue/apollo-composable';

import { getGraphqlSchema } from '../../graphql/index';
import { getLabel, EventBus } from '@/utils/index';
import { useMainStore } from '@/store/index';

export default {
  setup () {
    const router = useRouter();

    const store = useMainStore();

    const dialog = ref(false);

    const { group } = store;

    const itemsPerPage = 10;

    const page = ref(1);

    const collaboratorsToShow = computed(() => ref(store.group.collaborators).value || []);

    const totalPages = computed(() => (collaboratorsToShow.value.length > 0 ? Math.ceil(collaboratorsToShow.value.length / itemsPerPage) : -1));

    const collaboratorsHeaders = [
      { text: getLabel('name'), value: 'firstname', align: 'center' },
      { text: getLabel('phone'), value: 'mobilephone', align: 'center' },
      { text: getLabel('email'), value: 'email', align: 'center' },
      { text: getLabel('actions'), value: 'actions', align: 'center' }
    ];

    const collaboratorToRemove = ref({
      uuid: '',
      firstname: '',
      email: '',
      mobilephone: ''
    });

    const showDialog = collaborator => {
      collaboratorToRemove.value = collaborator;
      dialog.value = true;
    };

    // remove collaborator from group
    const { mutate: mutationRemoveCollaboratorFromGroup, onDone: onDoneRemove, onError: onErrorRemove } = useMutation(getGraphqlSchema('removeCollaboratorFromGroup'), () => ({
      variables: {
        uuid: store.group.uuid,
        collaborator: collaboratorToRemove.value.uuid
      }
    }));

    onErrorRemove(() => {
      store.loading = false;

      EventBus.$emit('show-notifications', [{
        message: getLabel('collaborator_remove_group_error'),
        type: 'danger'
      }]);
    });

    onDoneRemove(r => {
      store.loading = false;

      if (r.data.collaborator_remove_collaborator_from_group.success) {
        store.group.collaborators = [...r.data.collaborator_remove_collaborator_from_group.group.collaborators];

        EventBus.$emit('show-notifications', [{
          message: getLabel('collaborator_removed_group'),
          type: 'success'
        }]);

        EventBus.$emit('update-group', {
          uuid: store.group.uuid,
          collaborators_count: store.group.collaborators.length
        });
        return;
      }

      EventBus.$emit('show-notifications', [{
        message: getLabel('collaborator_add_group_error'),
        type: 'danger'
      }]);
    });

    /** ********* */

    const removeCollaborator = () => {
      dialog.value = false;

      store.loading = true;

      mutationRemoveCollaboratorFromGroup();
    };

    const addCollaborator = () => {
      store.addCollaboratorMode = true;
      store.cleanSearch();

      router.push({ name: 'dashboard' });
    };

    onActivated(() => {
      // change "addCollaboratorMode" here to avoid one aditional request of collaborators
      store.cleanSearch();

      store.addCollaboratorMode = false;
    });

    return {
      getLabel,
      dialog,
      showDialog,
      collaboratorsHeaders,
      group,
      itemsPerPage,
      page,
      collaboratorsToShow,
      totalPages,
      collaboratorToRemove,
      removeCollaborator,
      addCollaborator
    };
  }

};

</script>
